import { Grid, TextField, Tooltip, Typography } from "@mui/material";
import { TextView } from "../../TextView";
import { checkPermission } from "../../../Utils/Permissions";

function AgreementData({
  agreementData,
  setAgreementData,
  isReadOnly,
  readonlyData,
  doctor,
  isLive,
}) {
  return (
    <Grid container mb={2} lg={12}>
      <Grid container lg={12}>
        {!doctor && (
          <Grid item lg={3}>
            {!isReadOnly ? (
              <>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#2E2E2E",
                    paddingBottom: "7px",
                    paddingTop: "10px",
                  }}>
                  Contact Person Name
                </Typography>
                {checkPermission("KARE_DB_FINANCE_EDIT") && !isLive && (
                  <TextField
                    autoComplete="off"
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    placeholder="Add Contact Name"
                    sx={{ borderRadius: "5", width: 273, height: 54 }}
                    onChange={(e) => {
                      setAgreementData((s) => ({
                        ...s,
                        contactPersonName: e.target.value,
                      }));
                    }}
                  />
                )}
              </>
            ) : (
              <>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#2E2E2E",
                    paddingBottom: "7px",
                    paddingTop: "10px",
                  }}>
                  Contact Person Name
                </Typography>
                <TextView>
                  {readonlyData?.agreementResponse?.contactPersonName}
                </TextView>
              </>
            )}
          </Grid>
        )}
        {!doctor && (
          <Grid item lg={3} marginX={"30px"}>
            {!isReadOnly ? (
              <>
                {" "}
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#2E2E2E",
                    paddingBottom: "7px",
                    paddingTop: "10px",
                  }}>
                  Contact Person Number
                </Typography>
                {checkPermission("KARE_DB_FINANCE_EDIT") && !isLive && (
                  <TextField
                    autoComplete="off"
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    placeholder="Add Contact Number"
                    sx={{ borderRadius: "8", width: 273, height: 54 }}
                    onChange={(e) => {
                      setAgreementData((s) => ({
                        ...s,
                        contactPersonNumber: e.target.value,
                      }));
                    }}
                  />
                )}
              </>
            ) : (
              <>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "14px",
                    color: "#2E2E2E",
                    paddingBottom: "7px",
                    paddingTop: "10px",
                  }}>
                  Contact Person Number
                </Typography>
                <TextView>
                  {readonlyData?.agreementResponse?.contactPersonNumber}
                </TextView>
              </>
            )}
          </Grid>
        )}
        {/* agreement */}
        <Grid>
          {!isReadOnly ? (
            <>
              {" "}
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "#2E2E2E",
                  paddingBottom: "7px",
                  paddingTop: "10px",
                }}>
                Agreement Expiry
              </Typography>
              {checkPermission("KARE_DB_FINANCE_EDIT") && !isLive && (
                <Tooltip title="eg:(DD/MM/YYYY)">
                  <TextField
                    autoComplete="off"
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    type="date"
                    placeholder="From"
                    sx={{ borderRadius: "8", width: 173, height: 54 }}
                    onChange={(e) => {
                      setAgreementData((s) => ({
                        ...s,
                        agreementStartDate: e.target.value,
                      }));
                    }}
                  />
                </Tooltip>
              )}
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "#2E2E2E",
                  paddingBottom: "7px",
                  paddingTop: "10px",
                }}>
                Agreement Start
              </Typography>
              <TextView>
                {readonlyData?.agreementResponse?.agreementStartDate}
              </TextView>
            </>
          )}
        </Grid>

        <Grid
          lg={1}
          container
          // height={isEditable ? 150 : 100}
          alignItems={"center"}
          justifyContent={"center"}>
          <Typography>To</Typography>
        </Grid>
        <Grid>
          {!isReadOnly ? (
            <>
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "white",
                  paddingBottom: "7px",
                  paddingTop: "10px",
                }}>
                Agreement End
              </Typography>
              {checkPermission("KARE_DB_FINANCE_EDIT") && !isLive && (
                <Tooltip title="eg:(DD/MM/YYYY)">
                  <TextField
                    autoComplete="off"
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    type="date"
                    placeholder="From"
                    sx={{ borderRadius: "8", width: 173, height: 54 }}
                    onChange={(e) =>
                      setAgreementData((s) => ({
                        ...s,
                        agreementEndDate: e.target.value,
                      }))
                    }
                  />
                </Tooltip>
              )}
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "#2E2E2E",
                  paddingBottom: "7px",
                  paddingTop: "10px",
                }}>
                Agreement End
              </Typography>
              <TextView>
                {readonlyData?.agreementResponse?.agreementEndDate}
              </TextView>
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AgreementData;
